import React, { useState } from "react";
import parse from "html-react-parser";
import { Link } from 'react-router-dom';
import TV from '../../assets/images/TV2.jpg';
import YTPlayer from "../youtubePlayer/YTPlayer";

const opts = {
  playerVars: {
    controls:1,
    playsinline:1,
    modestbranding:1,
    autohide:0,
    showinfo:0,
    rel:0,
    showsearch:0,
    fs:0,
    disablekb:1,
    enablejsapi:1,
    webkitPlaysinline:1,
    iv_load_policy:1,
    },
};
const getVideo = () => {
  return (
    <YTPlayer videoid="FMYmniOtnus" opts={opts}></YTPlayer>
  )
}
const ListPage = (p) => {
  const [action, store] = [p.action, p.store];
  const [lang] = useState("esp");

  const updateLink = (link) => {
    store.currentText != null && action('UPDATE_CURRENT_TEXT', null);
    action('UPDATE_LINK', link);
  }
  const hasAdditionalContent = () => {
    return currentCategory === 'originala-prozo' || currentCategory === 'tradukita-poezio';
  }
  let currentCategory = decodeURIComponent(window.location.pathname.split('/')[1]);
  if ( currentCategory.startsWith('ruslingvaĵoj') ) {
    currentCategory = 'ruslingvaĵoj/'+decodeURIComponent(window.location.pathname.split('/')[2]);
  }

  const data = store.siteData.itemsList ? 
    store.siteData.itemsList.get(currentCategory) : 
    null;
  const itemLink = (item) => {
    return '/' + currentCategory + '/' + item.itemlink
  }
  const itemsList = () => {
    return (
      (!data || !data.map) ? null :
      data.map((item, index) => (
        <li key={index} className="list-group-item">
          <Link to={itemLink(item)} onClick={() => updateLink(itemLink(item))}>
          {parse(currentCategory.startsWith('ruslingvaĵoj') ? item.rus.itemName : item[lang].itemName)}
          </Link>
        </li>
      )) 
    )
  }
  return (
    <div className={hasAdditionalContent() ? 'page-content flex' : 'page-content'}>
      {currentCategory === 'originala-prozo' ? <div className="autoro">
        <img src={TV} alt="Tatjana Viktorovna Auderskaja" />
      </div> : null}
      <ul className="list-group">
        {itemsList()}
      </ul>
      {currentCategory === 'tradukita-poezio' ? <div className="auto-resizable-iframe ">
        {getVideo()}
      </div> : null}
    </div>
  )
}


export default ListPage;